/// *** System import ***///
import { Component } from '@angular/core';
import { ViewController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../../../app/globals';
import { SessionProvider } from '../../../../../providers/session';
import { Account_PortfolioStore } from '../../portfolio.store';

@Component({
  selector: 'page-account-portfolio-params',
  templateUrl: 'params.html',
})
export class Account_PortfolioParamsPopover {
  /// *** Data ***///
  private account: any;
  private balanceDate: Date;
  constructor(
    // *** System
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    // *** Custom 
    private globals: Globals,
    private session: SessionProvider,
    private store: Account_PortfolioStore) {
    this.account = this.session.accounts.find((account) => {
      return account.AccountID == this.store.params.account.AccountID;
    });
    this.balanceDate = this.store.params.balanceDate.toISOString();
  }

  // *** Fermer la fenêtre et appliquer les paramètres
  private _dismiss() {
    try {
      this.store.params.account = this.account;
      this.store.params.balanceDate = new Date(this.balanceDate);
      this.viewCtrl.dismiss();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.viewCtrl.dismiss();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/portfolio/popovers/params/params.ts